// extracted by mini-css-extract-plugin
export default {"imageWrapper":"DT-z","hovered":"ET-z","hoverImage":"FT-z","mainImage":"GT-z","imageNoBackground":"HT-z","fullSizeImage":"IT-z"};